export default __webpack_public_path__ + "scripts/resource/b57ad55a28ed5a7470a058b878b46ab0.svg";